import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import {Parts} from "../index";

class StandardNfaQuestions extends ObjectOverride {
	constructor(props) {
		super(props, Types.Standard_Nfa_Questions._name);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
	}


	handleQuestionSubmit = async () => {
		this.request = 'PUT';
		await this.model.submit(this, API.RequestType.CREATE);
	}

	render() {
		/** @type {Standard_Nfa_Questions} object */
		let object = this.state;
		let properties = this.model.properties;
		return <div>
			<h4 className="section-title">Standard Questions for ATF eForms</h4>
			<div className={'row'}>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						Applicant Type
					</p>
				</div>
				<div className={'col-sm-3'}>
					<div className={'form-group'}>
						<Framework.Elements.Select
							label={"Applicant Type"}
							shouldLoad={this.state.loaded}
							update={this.handleSelectPropertyUpdate}
							objects={[
								{pkey: '1', name: 'Individual'},
								{pkey: '2', name: 'Trust'},
								{pkey: '3', name: 'Corporation'},
								{pkey: '4', name: 'Other Legal Entity'},
								{pkey: '5', name: 'Government'},
							]}
							property={properties.applicant_type}
							value={this.state.applicant_type}
							error={this.state.applicant_type_error}
							text={'name'}
							nullable={true}
							limit={null}
						/>
					</div>
				</div>

				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						Location (Used for CLEO Autofill)
					</p>
				</div>
				<div className={'col-sm-3'}>
					<div className={'form-group'}>
						<Parts.SelectLocation
							object={object}
							properties={properties}
							shouldLoad={this.state.loaded}
							onSelectUpdate={this.handleSelectPropertyUpdate}
							locations={this.props.locations}
							states={this.props.states}
							filter={this.filterLocationOptions}
							nullable={false}
						/>
					</div>
				</div>


				{this.state.applicant_type === '1' &&
					<>
					<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.A. Do you intend to make any firearm listed on this form for sale or other disposition to any person described in
						questions
						11.c through 11.l, or a person described in question 11.m who does not fall under an exception?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['a']}
							value={object['a']}
							error={object['a_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.B. Do you intend to sell or otherwise dispose of any firearm listed on this form in furtherance of any felony or other
						offense punishable by imprisonment for a term of more than one year, a Federal crime of terrorism, or a drug trafficking
						offense?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['b']}
							value={object['b']}
							error={object['b_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.C. Are you under indictment or information in any court for a felony, or any other crime, for which the judge could
						imprison you for more than one year? (See definition 1.N)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['c']}
							value={object['c']}
							error={object['c_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.D. Have you ever been convicted in any court for a felony, or any other crime, for which the judge could have imprisoned
						you for more than one year, even if you received a shorter sentence including probation? (See definition 1.N)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['d']}
							value={object['d']}
							error={object['d_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.E. Are you a fugitive from justice? (See definition 1.T)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['e']}
							value={object['e']}
							error={object['e_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.F. Are you an unlawful user of, or addicted to, marijuana or any depressant, stimulant, narcotic drug, or any other
						controlled substance? Warning: The use or possession of marijuana remains unlawful under Federal law regardless of whether it
						has been legalized or decriminalized for medicinal or recreational purposes in the state where you reside.
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['f']}
							value={object['f']}
							error={object['f_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.G. Have you ever been adjudicated as a mental defective OR have you ever been committed to a mental institution? (See
						definition 1.O and 1.P)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['g']}
							value={object['g']}
							error={object['g_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.H. Have you been discharged from the Armed Forces under dishonorable conditions?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['h']}
							value={object['h']}
							error={object['h_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.I. Are you subject to a court order restraining you from harassing, stalking, or threatening your child or an intimate
						partner or child of such partner? (See definition 1.Q)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['i']}
							value={object['i']}
							error={object['i_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.J. Have you ever been convicted in any court of a misdemeanor crime of domestic violence? (See definition 1.R)
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['j']}
							value={object['j']}
							error={object['j_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.K. Have you ever renounced United States citizenship?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['k']}
							value={object['k']}
							error={object['k_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.L. Are you an alien illegally or unlawfully in the United States?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['l']}
							value={object['l']}
							error={object['l_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						11.M.1. Are you an alien who has been admitted to the United States under a nonimmigrant visa?
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['m']}
							value={object['m']}
							error={object['m_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				{object['m'] === true &&
					<>
						<div className={'col-sm-9'}>
							<p style={{marginBottom: 0}}>
								11.M.2. If "Yes", do you fall within any of the exceptions stated in the instructions? Attach the documentation in the
								application.
							</p>
						</div>
						<div className={'col-sm-3 text-right'}>
							<div className={'form-group'}>
								<Framework.Elements.ButtonSwitch
									property={this.model.properties['m2']}
									value={object['m2']}
									error={object['m2_error']}
									update={this.handleTextFieldPropertyUpdate}
									nullable={true}
									uncheck={true}
								/>
							</div>
						</div>
					</>}

				<div className={'col-sm-9'}>
					<p style={{marginBottom: 0}}>
						Are you a U.S. Citizen? Note: Additional info will be required to answer on the ATF E-Form site if your answer is no.
					</p>
				</div>
				<div className={'col-sm-3 text-right'}>
					<div className={'form-group'}>
						<Framework.Elements.ButtonSwitch
							property={this.model.properties['us_citizen']}
							value={object['us_citizen']}
							error={object['us_citizen_error']}
							update={this.handleTextFieldPropertyUpdate}
							nullable={true}
							uncheck={true}
						/>
					</div>
				</div>
				</>}
			</div>
			<Button style={{float: 'right'}} color={'primary'} onClick={this.handleQuestionSubmit}>
				Save
			</Button>
		</div>

	}
}


export default Framework.Components.withRootState(StandardNfaQuestions);
